/**
 * IFS (useifsapp.com) injects Instagram stories after page load and can relocate the
 * .stories carousel into the cart drawer. CSS covers known nodes; this removes any that
 * appear later (cart refresh, drawer open, app updates).
 */
(function () {
  const IFS_SELECTOR = [
    '#instagram-stories-box',
    '#instagram-feed-box',
    '#instafeed',
    '#stories',
    '#zuck-modal',
    '#instagram-promo-instructions',
    '.ifs-container',
    '.ifs-stories',
    '.stories',
    '.story-circle',
    '.story-circle-gradient',
    '.instastory-title',
    '.story-promo-tag',
    '[id^="ifs-"]',
    '[class*="ifs-"]'
  ].join(',');

  function removeIfsNodes(root) {
    (root || document).querySelectorAll(IFS_SELECTOR).forEach((node) => {
      node.remove();
    });
  }

  removeIfsNodes(document);

  if (typeof MutationObserver === 'undefined') return;

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(IFS_SELECTOR)) {
          node.remove();
          continue;
        }
        removeIfsNodes(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
